var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 466 408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6, .cls-9, .cls-10, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6, .cls-15, .cls-16, .cls-21 {\n        stroke: #000;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-10, .cls-12, .cls-13, .cls-17, .cls-18, .cls-19 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-16 {\n        stroke-width: 2.8px;\n      }\n\n      .cls-3 {\n        stroke-width: 3.4px;\n      }\n\n      .cls-22 {\n        fill: #825c41;\n      }\n\n      .cls-23 {\n        fill: #3b271b;\n      }\n\n      .cls-24 {\n        fill: #4d3423;\n      }\n\n      .cls-4, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11, .cls-14, .cls-15, .cls-16, .cls-20, .cls-21 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-14, .cls-17, .cls-18 {\n        stroke: #000d19;\n      }\n\n      .cls-4, .cls-14, .cls-18 {\n        stroke-width: 2.1px;\n      }\n\n      .cls-5, .cls-13, .cls-15, .cls-21 {\n        stroke-width: 3px;\n      }\n\n      .cls-6, .cls-7, .cls-20 {\n        stroke-width: 2px;\n      }\n\n      .cls-7 {\n        stroke: #42c763;\n      }\n\n      .cls-25 {\n        fill: #015e59;\n      }\n\n      .cls-26 {\n        fill: #faf9f8;\n      }\n\n      .cls-27 {\n        fill: #6e2f22;\n      }\n\n      .cls-28 {\n        fill: #f8d9bc;\n      }\n\n      .cls-8 {\n        stroke: #fff;\n      }\n\n      .cls-29 {\n        fill: #035eff;\n      }\n\n      .cls-30 {\n        fill: #f4b497;\n      }\n\n      .cls-31 {\n        fill: #bb2425;\n      }\n\n      .cls-32 {\n        fill: #66452e;\n      }\n\n      .cls-33 {\n        fill: #260809;\n      }\n\n      .cls-34 {\n        fill: #aa3d74;\n        opacity: .4;\n      }\n\n      .cls-35 {\n        fill: #4d1417;\n      }\n\n      .cls-36 {\n        fill: #eeb68c;\n      }\n\n      .cls-37 {\n        fill: #373db0;\n      }\n\n      .cls-38 {\n        fill: #ee927e;\n      }\n\n      .cls-39 {\n        fill: #f6c09c;\n      }\n\n      .cls-40 {\n        fill: #063842;\n      }\n\n      .cls-9 {\n        stroke: #f5c13d;\n        stroke-width: 3.1px;\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-50 {\n        fill: #e6eef2;\n      }\n\n      .cls-10 {\n        stroke: #033040;\n        stroke-width: 24.9px;\n      }\n\n      .cls-51 {\n        fill: #fff;\n      }\n\n      .cls-52 {\n        fill: #8cbab7;\n      }\n\n      .cls-11 {\n        stroke: #507e8f;\n        stroke-width: 3.2px;\n      }\n\n      .cls-53 {\n        fill: #ffd24a;\n      }\n\n      .cls-54 {\n        fill: #e3af5b;\n      }\n\n      .cls-55 {\n        fill: #42c763;\n      }\n\n      .cls-56 {\n        fill: #8c432b;\n      }\n\n      .cls-57 {\n        fill: #1b526d;\n      }\n\n      .cls-12 {\n        stroke-width: 3.4px;\n      }\n\n      .cls-12, .cls-13, .cls-19 {\n        stroke: #eeb68c;\n      }\n\n      .cls-58 {\n        fill: #000d19;\n      }\n\n      .cls-59 {\n        fill: #f8c79d;\n      }\n\n      .cls-60 {\n        fill: #0d5359;\n      }\n\n      .cls-61 {\n        fill: #63e06b;\n      }\n\n      .cls-62 {\n        fill: #8ff584;\n      }\n\n      .cls-63 {\n        fill: #073f4a;\n      }\n\n      .cls-64 {\n        fill: #e12129;\n      }\n\n      .cls-65 {\n        fill: #c6cfce;\n      }\n\n      .cls-66 {\n        fill: #ffae4a;\n      }\n\n      .cls-67 {\n        fill: #556ec9;\n      }\n\n      .cls-68 {\n        fill: #052b33;\n      }\n\n      .cls-69 {\n        fill: #360b0e;\n      }\n\n      .cls-70 {\n        fill: #fa98be;\n      }\n\n      .cls-17 {\n        stroke-width: 2.3px;\n      }\n\n      .cls-19 {\n        stroke-width: 2.3px;\n      }\n\n      .cls-20 {\n        stroke: #d99037;\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-72 {\n        fill: #002131;\n      }\n\n      .cls-73 {\n        fill: #154259;\n      }\n\n      .cls-74 {\n        fill: #dde7e9;\n      }\n\n      .cls-75 {\n        fill: #033040;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M212.7,186.2h24.3c7.2,0,13,5.8,13,13v4.3c0,3.9-3.1,7-7,7h-36.3c-3.9,0-7-3.1-7-7v-4.3c0-7.2,5.8-13,13-13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M268.7,148.9h-19.6c-4,0-6.4-4.6-4.1-7.9l1.4-2c6.1-8.6,18.8-8.6,24.8,0l1.4,2c2.3,3.3,0,7.9-4.1,7.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M211.1,148.9h19.6c4,0,6.4-4.6,4.1-7.9l-1.4-2c-6.1-8.6-18.8-8.6-24.8,0l-1.4,2c-2.3,3.3,0,7.9,4.1,7.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 113.4,
    y: 137.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 153,
    y: 137.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M379.9,191.3h20.3c9.6,0,17.4,7.8,17.4,17.4v7.4c0,3.5-2.8,6.3-6.3,6.3h-42.4c-3.5,0-6.3-2.8-6.3-6.3v-7.4c0-9.6,7.8-17.4,17.4-17.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 381.6,
    y: 132.5,
    width: 22.7,
    height: 31.8,
    rx: 11.4,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 418.6,
    y: 132.5,
    width: 22.7,
    height: 31.8,
    rx: 11.4,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M309.4,141.2h-20.1c-4.1,0-6.6,4.7-4.2,8.1l1.5,2.1c6.2,8.8,19.3,8.8,25.5,0l1.5-2.1c2.4-3.4,0-8.1-4.2-8.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M351.1,141.2h-20.1c-4.1,0-6.6,4.7-4.2,8.1l1.5,2.1c6.2,8.8,19.3,8.8,25.5,0l1.5-2.1c2.4-3.4,0-8.1-4.2-8.1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.8,75.4h40.7c11.8,0,21.4,9.6,21.4,21.4v103.2c0,20-16.3,36.3-36.3,36.3h-26.5c-20,0-36.3-16.3-36.3-36.3v-87.5c0-20.5,16.6-37.1,37.1-37.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 234.3,
    y: 182.7,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(485.8 418.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 234.3,
    y: 218.7,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(485.8 490.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 248.6,
    cy: 263.9,
    r: 14.3
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 207.6,
    y: 207.7,
    width: 34.4,
    height: 26.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M212.7,186.2h24.3c7.2,0,13,5.8,13,13v4.3c0,3.9-3.1,7-7,7h-36.3c-3.9,0-7-3.1-7-7v-4.3c0-7.2,5.8-13,13-13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M211.2,186.2h32.5v5.8c0,4.7-3.8,8.6-8.6,8.6h-15.4c-4.7,0-8.6-3.8-8.6-8.6v-5.8h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M215.7,226.6h18.3c12.4,0,22.4,10,22.4,22.4v9.5h-63.1v-9.5c0-12.4,10-22.4,22.4-22.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 207.6,
    y: 223.5,
    width: 34.4,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M199.4,351.9l-3.5-9.2c-3.1-8.3,3-17.1,11.8-17.1h0c8.9,0,15,8.9,11.8,17.1l-3.5,9.2c-2.9,7.7-13.8,7.7-16.7,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 207.6,
    y: 209.1,
    width: 34.4,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M200.2,330h15.2v6.7c0,2.8-2.3,5.2-5.2,5.2h-4.9c-2.8,0-5.2-2.3-5.2-5.2v-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M207.8,310.1c-8,0-14.5-6.5-14.5-14.5v-41.1c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5v41.1c0,8-6.5,14.5-14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M193.3,336.7v-41.1c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5v41.1h-29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 195.1,
    y: 198.5,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 195.1,
    y: 234.5,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 198.1,
    cy: 279.7,
    r: 14.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M233.6,339.2l-3.5-9.2c-3.1-8.3,3-17.1,11.8-17.1h0c8.9,0,15,8.9,11.8,17.1l-3.5,9.2c-2.9,7.7-13.8,7.7-16.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M234.3,317.4h15.2v6.7c0,2.8-2.3,5.2-5.2,5.2h-4.9c-2.8,0-5.2-2.3-5.2-5.2v-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M241.9,300.6c-8,0-14.5-6.5-14.5-14.5v-41.1c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5v41.1c0,8-6.5,14.5-14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M227.4,324.1v-41.1c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5v41.1h-29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.4,227.5c-.7-.7-1.9-.7-2.6,0s-.7,1.9,0,2.6l2.6,2.6,2.6-2.6c.7-.7.7-1.9,0-2.6s-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M215.3,227.5c-.7-.7-1.9-.7-2.6,0s-.7,1.9,0,2.6l2.6,2.6,2.6-2.6c.7-.7.7-1.9,0-2.6s-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.4,227.5c-.7-.7-1.9-.7-2.6,0s-.7,1.9,0,2.6l2.6,2.6,2.6-2.6c.7-.7.7-1.9,0-2.6s-1.9-.7-2.6,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M227.4,238.4h4.6v11.2c0,2.5-2.1,4.6-4.6,4.6h0v-15.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M220.6,66.6h13.7c21.5,0,39,17.5,39,39v29.7c0,8.7-7.1,15.8-15.8,15.8h-60c-8.7,0-15.8-7.1-15.8-15.8v-29.7c0-21.5,17.5-39,39-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M215.2,94.7h38.8c11.7,0,21.1,9.5,21.1,21.1v39.7c0,18.7-15.2,33.9-33.9,33.9h-13.2c-18.7,0-33.9-15.2-33.9-33.9v-39.7c0-11.7,9.5-21.1,21.1-21.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 215.2,
    y: 171,
    width: 19.4,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M241.9,144l7.3,20.7c.6,1.8-.7,3.6-2.6,3.6h-3.3c-2,0-3.7-1.6-3.7-3.7v-20.3c0-1.3,1.8-1.6,2.2-.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M268.7,148.9h-19.6c-4,0-6.4-4.6-4.1-7.9l1.4-2c6.1-8.6,18.8-8.6,24.8,0l1.4,2c2.3,3.3,0,7.9-4.1,7.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 256.5,
    y: 137,
    width: 14.3,
    height: 24,
    rx: 7.2,
    ry: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 255,
    y: 134.4,
    width: 6.1,
    height: 11.2,
    rx: 3.1,
    ry: 3.1
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.6,141.8s4.8-9.2,14.3-9.2,14.3,9.2,14.3,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 271.6,
    y1: 132.3,
    x2: 268.3,
    y2: 135.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 266.6,
    y1: 129.3,
    x2: 264.6,
    y2: 133.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 275.5,
    y1: 136.1,
    x2: 271.8,
    y2: 139.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M211.1,148.9h19.6c4,0,6.4-4.6,4.1-7.9l-1.4-2c-6.1-8.6-18.8-8.6-24.8,0l-1.4,2c-2.3,3.3,0,7.9,4.1,7.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 218.1,
    y: 137,
    width: 14.3,
    height: 24,
    rx: 7.2,
    ry: 7.2,
    transform: "translate(450.6 298) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 216.4,
    y: 134.4,
    width: 6.1,
    height: 11.2,
    rx: 3.1,
    ry: 3.1,
    transform: "translate(439 280.1) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.2,141.8s-4.8-9.2-14.3-9.2c-10.3,0-14.3,9.2-14.3,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 208.2,
    y1: 132.3,
    x2: 211.5,
    y2: 135.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 213.2,
    y1: 129.3,
    x2: 215.2,
    y2: 133.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 204.3,
    y1: 136.1,
    x2: 208,
    y2: 139.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M268.7,143.4h11.5v2.3c0,7.2-5.9,13.1-13.1,13.1h0c-2.8,0-5-2.2-5-5v-3.8c0-3.7,3-6.7,6.7-6.7Z",
    transform: "translate(542.1 302.2) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M204.2,143.4h0c7.2,0,13.1,5.9,13.1,13.1v2.3h-11.5c-3.7,0-6.7-3-6.7-6.7v-3.8c0-2.8,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 205.5,
    cy: 156.3,
    r: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M230.1,100.8h-9.2c-15.4,0-27.9,12.5-27.9,27.9v87.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 274.3,
    cy: 156.3,
    r: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M240.4,176.3s-1.7-3.8-7-6c-5.3-2.3-9.4-.5-9.4-.5,0,0,1.5,4.1,7.1,6.4,4,1.6,9.3.1,9.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.6,100.8h9.2c15.4,0,27.9,12.5,27.9,27.9v87.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M221.9,167.2c2.4,7.8,10.7,12.2,18.5,9.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M163.5,100.3s-2.3-11,6.3-28.1c8.5-17.1,4.8-15.6,2.1-16.5s-22.6,35.6-22.6,35.6l-14.1-4.7s1.8-16.5,15.4-41.1c13.6-24.6,54.1-38.5,98.3-9.4,44.2,29.1,27.8,65.7,27.8,65.7l-113.1-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M171.8,55.7c-.2,0-.6,0-1,.5.9-8.8-5.5-18-5.5-18,4.8,2,4.9,4.8,4.9,4.8,1.6-4.9,5.3-6.2,5.3-6.2-9.1,23.5,7.4,16.9,7.4,16.9,2.6-18.5,26.6-18.8,26.6-18.8-21.4,7.1-17.8,17.9-17.8,17.9,17-2,26.1,4.4,26.1,4.4-6.1,2.8-15.6,2.3-20.1.6-4.4-1.6-10.5-4.8-20.5,6.3-10,11.1-7.4,26-7.4,26,65.1-18.7,103.4-10,103.4-10l6.2,6.1c-.2,9.4-3,15.7-3,15.7l-113.1-1.4s-2.3-11,6.3-28.1c8.5-17.1,4.8-15.6,2.1-16.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 136.1,
    cy: 104.4,
    rx: 22.2,
    ry: 19.7,
    transform: "translate(-14.7 22.7) rotate(-9.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M135,116.9c12.1-1.9,20.6-12.2,18.9-22.9s-.3-1.7-.6-2.5c2.5,2.6,4.2,5.9,4.8,9.5,1.7,10.7-6.7,21-18.9,22.9-11.1,1.8-21.5-4.1-24.5-13.4,4.7,5,12.3,7.7,20.3,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M223.8,84.9c-66.7,10.6-79.4,12.4-67.3,37.8,12.2,25.4,22.5,6.6,70.6,1.2,48.1-5.4,72.5-.2,69.4-26.1s-13.8-22.4-72.8-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M156.4,101c.3,5.7,4.1,12,5.1,16.5,1.7,7.1,9.4,10.8,41.4,1,32.1-9.7,63.6-9.2,77.1-10,7.1-.4,13-3,16.9-6.4-.2,21-24.4,16.8-69.7,21.8-48.1,5.4-58.5,24.1-70.6-1.2-5-10.5-5.8-17-.2-21.7Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M142.8,368.3c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M133,356h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(298.2 730.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 141.9,
    y: 282.4,
    width: 17.6,
    height: 14,
    transform: "translate(301.4 578.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M150.7,262.8c6.8,0,12.4-5.5,12.4-12.4v-28.7c0-6.8-5.5-12.4-12.4-12.4-6.8,0-12.4,5.5-12.4,12.4v28.7c0,6.8,5.5,12.4,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M138.4,250.8v30.4c0,1.8,1.5,3.2,3.2,3.2h18.2c1.8,0,3.2-1.5,3.2-3.2v-30.8c0-7-5.9-12.7-13-12.3-6.6.3-11.8,6-11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 155.9,
    cy: 296.4,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 127.9,
    y: 344,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M116.8,336.8c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M116.8,381.8c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M142.8,323.3c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M123.2,258.1h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M131.9,265.9h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M112.9,211.9h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 116.5,
    y: 197.9,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M113.3,201.5h29.1c2.4,0,4.4,2,4.4,4.4v8.9h-37.8v-8.9c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M107,369.6h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(246.2 757.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 101.9,
    y: 357.5,
    width: 29.7,
    height: 22.5,
    transform: "translate(233.6 737.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 82.5,
    cy: 98.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 95.3,
    cy: 90.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 73.1,
    cy: 107.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 66,
    cy: 118.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 60,
    cy: 130.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 57.8,
    cy: 143.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 56.8,
    cy: 156.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 56.8,
    cy: 170,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 58.2,
    cy: 181.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 169.9,
    cy: 98.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 157.1,
    cy: 90.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 179.2,
    cy: 107.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 186.3,
    cy: 118.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 192.4,
    cy: 130.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 194.6,
    cy: 143.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 195.6,
    cy: 156.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 195.6,
    cy: 170,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 194.2,
    cy: 181.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M125.1,78.1h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 178.9,
    cy: 152.2,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 88.5,
    cy: 152.2,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M121.3,73.5h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.1,160.8c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.5,160.8c-6.4,0-11.5,5.2-11.5,11.5,0,6.4,5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5c0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M121.1,110.4h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M151.7,180.5c1.8,0,3,1.9,2.1,3.5-2.5,4.5-7.2,7.6-12.8,7.6s-10.3-3.1-12.8-7.6.3-3.5,2.1-3.5h21.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 113.4,
    y: 137.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 121.2,
    y: 145.6,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 120.3,
    y: 142.6,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M113.4,148.1v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 109.9,
    y1: 144.4,
    x2: 113.6,
    y2: 145.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 111.3,
    y1: 140.4,
    x2: 114.8,
    y2: 142.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M109,160h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 109.3,
    cy: 172.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 153,
    y: 137.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 160.2,
    y: 145.6,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 159.3,
    y: 142.6,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M174,148.1v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 177.6,
    y1: 144.4,
    x2: 173.8,
    y2: 145.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 176.1,
    y1: 140.4,
    x2: 172.6,
    y2: 142.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M169.4,160h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(342.7 335.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 175,
    cy: 171.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M156.8,144.2h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M113.9,144.2h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M138.9,153.7s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M144.1,155.4v15.3c0,2.2,1.8,4,4,4h2.4c3,0,5-3.2,3.6-5.9l-7.2-14.1c-.7-1.4-2.8-.9-2.8.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M101.2,113.1h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 103.8,
    cy: 121.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 103.1,
    cy: 116.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 110.4,
    cy: 114.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 120.2,
    cy: 109.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 131.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 141.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 150.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 177.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 187.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 196.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 159.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 99.7,
    cy: 168.7,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M189.5,111.2h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(366 312) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 172.6,
    cy: 119.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 166,
    cy: 112.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 156.2,
    cy: 107.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 129.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 139.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 148.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 175.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 185.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 194.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 157.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 176.7,
    cy: 166.8,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 92.9,
    y: 295.4,
    width: 17.6,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M101.7,275.7c-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4s12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M114,263.7v30.4c0,1.8-1.5,3.2-3.2,3.2h-18.2c-1.8,0-3.2-1.5-3.2-3.2v-30.8c0-7,5.9-12.7,13-12.3,6.6.3,11.8,6,11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 96.5,
    cy: 309.4,
    r: 14
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 129.8,
    y1: 286,
    x2: 129.8,
    y2: 355.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M59.4,112.7s-3.1-9.8,4.7-26.4,4-14.8,1.1-15.3-21.1,35.1-21.1,35.1l-14.9-2.7s.8-15.3,13.3-39.3c12.5-24.1,53.5-41.4,101-20,47.5,21.4,32.9,56.8,32.9,56.8l-117,11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M65.2,71c-.2,0-.6.1-1,.5.3-8.1-6.8-15.8-6.8-15.8,5.1,1.3,5.4,3.8,5.4,3.8,1.3-4.6,5.1-6.2,5.1-6.2-7.9,22.5,8.7,14.6,8.7,14.6,1.5-17.2,26.3-20.3,26.3-20.3-21.6,9-17.3,18.4-17.3,18.4,17.4-3.8,27.3,1,27.3,1-6.1,3.3-16,3.9-20.7,2.9-4.7-1-11.1-3.2-20.8,8.1-9.6,11.3-6,24.6-6,24.6,66.1-24.6,106.2-21.1,106.2-21.1l6.8,4.8c.4,8.6-2.1,14.6-2.1,14.6l-117,11.8s-3.1-9.8,4.7-26.4,4-14.8,1.1-15.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 31.4,
    cy: 119.6,
    rx: 23.2,
    ry: 17.9,
    transform: "translate(-28.6 11.5) rotate(-14.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M31.1,131.1c12.4-3.2,20.5-13.5,18-23.1-.2-.8-.5-1.5-.8-2.2,2.7,2.1,4.7,4.9,5.5,8.2,2.5,9.6-5.6,19.9-18,23.1s-22.5-1.3-26.1-9.4c5.2,4,13.2,5.6,21.4,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M120.9,91.6c-68.3,17.4-81.3,20.6-67.1,42.3,14.2,21.8,23.7,3.4,73.1-7.1,49.4-10.5,74.9-8.6,70.1-31.9s-15.7-18.8-76-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M52.1,114.1c.6,5.1,5,10.5,6.4,14.5,2.2,6.3,10.4,8.8,42.9-3.9,32.5-12.6,65.1-15.8,79-18,7.3-1.2,13.3-4.2,17-7.8,1.2,19.2-24.2,18.1-70.6,28-49.4,10.5-58.9,28.8-73.1,7.1-5.9-9-7.1-14.9-1.6-19.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 390,
    y: 241.2,
    width: 22.2,
    height: 65.8,
    rx: 11.1,
    ry: 11.1,
    transform: "translate(802.2 548.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390,284.9h22.2v54.7c0,6.1-5,11.1-11.1,11.1h0c-6.1,0-11.1-5-11.1-11.1v-54.7h0Z",
    transform: "translate(802.2 635.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 390,
    y: 325.5,
    width: 22.2,
    height: 13.3,
    transform: "translate(802.2 664.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M395,337.5h33.3v13.1h-30.2c-4.5,0-8.1-3.6-8.1-8.1h0c0-2.8,2.2-5,5-5Z",
    transform: "translate(818.3 688.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 369,
    y: 252.5,
    width: 22.2,
    height: 65.8,
    rx: 11.1,
    ry: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.1,296.2h0c6.1,0,11.1,5,11.1,11.1v54.7h-22.2v-54.7c0-6.1,5-11.1,11.1-11.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 369,
    y: 336.8,
    width: 22.2,
    height: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M374,348.8h33.3v13.1h-30.2c-4.5,0-8.1-3.6-8.1-8.1h0c0-2.8,2.2-5,5-5Z",
    transform: "translate(776.3 710.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 391,
    y1: 283.2,
    x2: 391,
    y2: 334.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 399.3,
    y: 190.3,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(815.9 434) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 399.3,
    y: 226.3,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(815.9 505.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.6,
    cy: 271.5,
    r: 14.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M390,229.5h30.4v43.6h-16c-7.9,0-14.4-6.4-14.4-14.4v-29.2h0Z",
    transform: "translate(810.4 502.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 390,
    y: 263.8,
    width: 32.8,
    height: 9.3,
    transform: "translate(812.8 536.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 369.6,
    y: 218.8,
    width: 40.8,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 369.6,
    y: 220.9,
    width: 40.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M379.9,191.3h20.3c9.6,0,17.4,7.8,17.4,17.4v7.4c0,3.5-2.8,6.3-6.3,6.3h-42.4c-3.5,0-6.3-2.8-6.3-6.3v-7.4c0-9.6,7.8-17.4,17.4-17.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M373.9,189.8h32.1c0,6.3-5.1,11.4-11.4,11.4h-9.3c-6.3,0-11.4-5.1-11.4-11.4h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M369.6,232.2h40.8v8.9c0,7.4-6,13.4-13.4,13.4h-13.9c-7.4,0-13.4-6-13.4-13.4v-8.9h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 372.7,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 379.1,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 385.5,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 391.8,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 398.2,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 404.6,
    y: 232.2,
    width: 2.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M374,238.1h23.8v43.6h-38.2v-29.2c0-7.9,6.4-14.4,14.4-14.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 357.2,
    y: 272.4,
    width: 43.9,
    height: 9.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M402.7,242.2h5v9c0,2.8-2.3,5-5,5h0v-14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M390,58.5h0c-26.3,0-49.2,17.7-55.9,43.1l-15.2,58.2c-4.2,15.9,7.8,31.4,24.3,31.4h33.5c46.9,0,81.1-44.3,69.2-89.6h0c-6.6-25.4-29.6-43.1-55.9-43.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M331.6,129.7c1,19.7,18.7,23.9,33.6,10.4,14.9-13.5-6.6-32.9-6.6-32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M370.5,112.1h72v40.4c0,21.4-17.4,38.8-38.8,38.8h-18.9c-13.1,0-23.7-10.6-23.7-23.7v-46.1c0-5.2,4.2-9.4,9.4-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.3,94.5h25.1c15.5,0,28.1,12.6,28.1,28.1v35.4c0,18.1-14.7,32.7-32.7,32.7h-15.9c-18.1,0-32.7-14.7-32.7-32.7v-35.4c0-15.5,12.6-28.1,28.1-28.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 378,
    y: 176.3,
    width: 24.1,
    height: 17.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M392.6,85.9h17.7c21.3,0,38.7,17.3,38.7,38.7v1.3h-32.9c-13,0-23.5-10.5-23.5-23.5v-16.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M416.6,182.9c-7.8,2.5-16.1-1.7-18.7-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M413.1,152.3l6,16.9c.5,1.4-.6,3-2.1,3h-2.7c-1.7,0-3-1.3-3-3v-16.5c0-1,1.4-1.3,1.8-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 381.6,
    y: 132.5,
    width: 22.7,
    height: 31.8,
    rx: 11.4,
    ry: 11.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 389.1,
    y: 141.6,
    width: 12.6,
    height: 21.2,
    rx: 6.3,
    ry: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 388.1,
    y: 138.3,
    width: 6.9,
    height: 12.6,
    rx: 3.5,
    ry: 3.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M381.6,144.1v-.2c0-6.3,5.1-11.4,11.4-11.4h0c6.3,0,11.4,5.1,11.4,11.4v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 377.8,
    y1: 140.1,
    x2: 381.9,
    y2: 141.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 379.4,
    y1: 135.8,
    x2: 383.1,
    y2: 137.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 418.6,
    y: 132.5,
    width: 22.7,
    height: 31.8,
    rx: 11.4,
    ry: 11.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 426,
    y: 141.6,
    width: 12.6,
    height: 21.2,
    rx: 6.3,
    ry: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 425.1,
    y: 138.3,
    width: 6.9,
    height: 12.6,
    rx: 3.5,
    ry: 3.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M418.6,144.1v-.2c0-6.3,5.1-11.4,11.4-11.4h0c6.3,0,11.4,5.1,11.4,11.4v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 445.3,
    y1: 140.1,
    x2: 441.2,
    y2: 141.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 443.7,
    y1: 135.8,
    x2: 440,
    y2: 137.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.3,156.7h0c6.4,0,11.6,5.2,11.6,11.6v2h-10.1c-3.2,0-5.9-2.6-5.9-5.9v-3.3c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434,156.7h9.2v5.5c0,4.5-3.6,8.1-8.1,8.1h0c-3.2,0-5.8-2.6-5.8-5.8v-3.2c0-2.6,2.1-4.7,4.7-4.7Z",
    transform: "translate(872.6 327) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.1,
    y: 206.7,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.1,
    y: 242.6,
    width: 17.3,
    height: 53.3,
    rx: 8.7,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364,
    cy: 287.9,
    r: 14.3
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "397.8 272.4 397.8 259.1 402.7 259.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M333.2,107.1s-3.1-10.4,3-27.4c6.2-17.1,2.9-15.3.3-16s-17.3,35.9-17.3,35.9l-13.4-3.4s0-16,10.2-40.6c10.1-24.7,45.9-41.1,89.2-16.6,43.3,24.5,31.7,60.9,31.7,60.9l-103.8,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.5,63.6c-.2,0-.5.1-.8.5,0-8.5-6.7-16.8-6.7-16.8,4.6,1.6,5,4.2,5,4.2,1-4.8,4.3-6.3,4.3-6.3-6.1,23.2,8.4,15.6,8.4,15.6.6-18,22.6-20.1,22.6-20.1-18.9,8.5-14.6,18.5-14.6,18.5,15.4-3.2,24.3,2.2,24.3,2.2-5.3,3.2-14.1,3.4-18.3,2.2-4.2-1.2-10-3.8-18.2,7.6-8.1,11.4-4.3,25.5-4.3,25.5,57.9-23,93.8-17.6,93.8-17.6l6.2,5.3c.7,9-1.2,15.2-1.2,15.2l-103.8,7.4s-3.1-10.4,3-27.4c6.2-17.1,2.9-15.3.3-16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 308.5,
    cy: 113.1,
    rx: 20.4,
    ry: 19,
    transform: "translate(-18.4 79.9) rotate(-14.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M308.7,125.1c10.9-2.8,17.7-13.3,15.1-23.4-.2-.8-.5-1.6-.8-2.4,2.5,2.3,4.4,5.3,5.3,8.8,2.6,10.2-4.2,20.6-15.1,23.4s-20.1-2.3-23.7-11c4.8,4.4,12,6.4,19.2,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M387,87.6c-60.1,15.4-71.6,18.1-58,41.5s21.3,4.6,64.9-4.3c43.6-8.9,66.4-5.8,61.1-30.4-5.3-24.6-14.8-20.4-67.9-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M326.7,108.3c.8,5.4,4.9,11.2,6.3,15.5,2.2,6.7,9.6,9.6,38.1-2.2,28.4-11.8,57.4-13.8,69.7-15.5,6.5-.9,11.6-3.9,14.8-7.5,1.8,20.2-20.8,18-61.8,26.3-43.6,8.9-51.3,27.7-64.9,4.3-5.6-9.7-6.9-15.9-2.3-20.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.9,
    y: 220.9,
    width: 18.5,
    height: 57,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(703.2 428.7) rotate(168.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M311.1,210.6h29.8v25.3c0,7.7-6.3,14-14,14h-1.8c-7.7,0-14-6.3-14-14v-25.3h0Z",
    transform: "translate(691.1 391.5) rotate(168.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 341.8,
    y: 231,
    width: 18.5,
    height: 57,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(420.8 -171.5) rotate(62.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M286.5,177.7h13.8v17.3c0,13.3-10.8,24.2-24.2,24.2h-12.3v-18.9c0-12.5,10.1-22.6,22.6-22.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M264.6,139.9h95.6v26.5c0,13.4-10.9,24.2-24.2,24.2h-47.1c-13.4,0-24.2-10.9-24.2-24.2v-26.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M298.5,349.6c-5.6,0-10.2-4.6-10.2-10.2v-49.8c0-5.6,4.6-10.2,10.2-10.2s10.2,4.6,10.2,10.2v49.8c0,5.6-4.6,10.2-10.2,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M288.3,389.2v-49.8c0-5.6,4.6-10.2,10.2-10.2s10.2,4.6,10.2,10.2v49.8h-20.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M292.7,383.9h33.5v14.1h-29c-4.9,0-8.9-4-8.9-8.9v-.9c0-2.4,2-4.4,4.4-4.4Z",
    transform: "translate(614.5 782) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M318.8,335.6c5.6,0,10.2-4.6,10.2-10.2v-49.8c0-5.6-4.6-10.2-10.2-10.2s-10.2,4.6-10.2,10.2v49.8c0,5.6,4.6,10.2,10.2,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M329,375.3v-49.8c0-5.6-4.6-10.2-10.2-10.2-5.6,0-10.2,4.6-10.2,10.2v49.8s20.3,0,20.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M313.1,370h33.5v14.1h-29c-4.9,0-8.9-4-8.9-8.9v-.9c0-2.4,2-4.4,4.4-4.4Z",
    transform: "translate(655.2 754.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M298.4,210h20.4c11.1,0,20,9,20,20v63.7h-60.5v-63.7c0-11.1,9-20,20-20Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 350.5,
    cy: 153.7,
    r: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 275.1,
    cy: 153.7,
    r: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M294.9,81.7h34.9c16.7,0,30.3,13.6,30.3,30.3v27.6c0,5.2-4.3,9.5-9.5,9.5h-76.6c-5.2,0-9.5-4.3-9.5-9.5v-27.6c0-16.7,13.6-30.3,30.3-30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.8,98.5h38.5c11.1,0,20.2,9,20.2,20.2v56c0,18.3-14.8,33.1-33.1,33.1h-12.6c-18.3,0-33.1-14.8-33.1-33.1v-56c0-11.1,9-20.2,20.2-20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.5,189.7h20.3v21.1c0,5.3-4.3,9.5-9.5,9.5h-1.2c-5.3,0-9.5-4.3-9.5-9.5v-21.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M336.8,179.4c-6.1,6.1-15.9,6.1-22,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M289.3,137.9h20.1c2.8,0,5.1,2.3,5.1,5.1v3h-30.3v-3c0-2.8,2.3-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M309.4,141.2h-20.1c-4.1,0-6.6,4.7-4.2,8.1l1.5,2.1c6.2,8.8,19.3,8.8,25.5,0l1.5-2.1c2.4-3.4,0-8.1-4.2-8.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 296.8,
    y: 131.1,
    width: 14.7,
    height: 24.6,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(608.2 286.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 294.8,
    y: 145.9,
    width: 6.3,
    height: 11.5,
    rx: 3,
    ry: 3,
    transform: "translate(595.9 303.4) rotate(-180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M331,137.9h20.1c2.8,0,5.1,2.3,5.1,5.1v3h-30.3v-3c0-2.8,2.3-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M351.1,141.2h-20.1c-4.1,0-6.6,4.7-4.2,8.1l1.5,2.1c6.2,8.8,19.3,8.8,25.5,0l1.5-2.1c2.4-3.4,0-8.1-4.2-8.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 338.5,
    y: 131.1,
    width: 14.7,
    height: 24.6,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(691.6 286.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 336.5,
    y: 145.9,
    width: 6.3,
    height: 11.5,
    rx: 3,
    ry: 3,
    transform: "translate(679.2 303.4) rotate(-180)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M327.2,142.1c-.5-1.6-2.3-1.6-2.8,0-2,6.1-5.6,15.6-5.6,24.4s7,8.1,7,8.1c0,0,7-.5,7-8.1s-3.6-18.3-5.6-24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M350.5,194.9v8.1c0,7.8-6.3,14.1-14.1,14.1h-21.7c-7.8,0-14.1-6.3-14.1-14.1v-8.1c0-3,2.4-5.4,5.4-5.4h.9c1.9,0,3.4,1.5,3.4,3.4v5.2c0,2.8,2.3,5.2,5.2,5.2h20.2c2.8,0,5.2-2.3,5.2-5.2v-5.2c0-1.9,1.5-3.4,3.4-3.4h.9c3,0,5.4,2.4,5.4,5.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "332.5 228 308.5 252.5 317.8 255.5 305.1 278.5 332.5 252.5 322.7 248.5 332.5 228"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.8,146.1h22.3c1.9,0,3.5,1.6,3.5,3.5v5.3c0,2.9-2.4,5.3-5.3,5.3h-18.7c-2.9,0-5.3-2.4-5.3-5.3v-5.3c0-1.9,1.6-3.5,3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.4,146.1h22.3c1.9,0,3.5,1.6,3.5,3.5v5.3c0,2.9-2.4,5.3-5.3,5.3h-18.7c-2.9,0-5.3-2.4-5.3-5.3v-5.3c0-1.9,1.6-3.5,3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.2,153.5s2.4-3.7,7.5-3.7,7.5,3.7,7.5,3.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 362.6,
    y1: 151.1,
    x2: 366.3,
    y2: 151.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 285.3,
    y1: 151.1,
    x2: 288.9,
    y2: 151.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M329.5,194.2l-1.7,2.3c-.9,1.2-2.7,1.2-3.6,0l-1.7-2.3c-.9-1.2,0-3,1.5-3h4c1.5,0,2.4,1.7,1.5,3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 308.8,
    y1: 293.7,
    x2: 308.8,
    y2: 381
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M337.6,126.4h18.3c2.4,0,4.3,1.9,4.3,4.3v1.4c0,1.2-1,2.2-2.2,2.2h-22.4c-1.2,0-2.2-1-2.2-2.2v-1.4c0-2.4,1.9-4.3,4.3-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M295.9,126.4h18.3c2.4,0,4.3,1.9,4.3,4.3v1.4c0,1.2-1,2.2-2.2,2.2h-22.4c-1.2,0-2.2-1-2.2-2.2v-1.4c0-2.4,1.9-4.3,4.3-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M325.4,97.8h20.1v3.7h-16.7c-1.9,0-3.4-1.5-3.4-3.4v-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M291.3,97.8h35v3.7h-38.4v-.2c0-1.9,1.5-3.4,3.4-3.4Z",
    transform: "translate(614.1 199.2) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M221.4,146.3c13.2,8.1,25.6,17.2,37.8,26.6,12.2,9.4,24.1,19.3,35.8,29.5,11.7,10.2,23.3,20.4,35.3,30.1,12,9.7,24.2,19.1,37.5,27,2.7,1.6,3.5,5,2,7.7-1.6,2.7-5,3.5-7.7,2-.2-.1-.5-.3-.7-.5-11.9-9.9-24.8-18.3-38-26.3-13.2-8.1-26.7-15.6-40.2-23.2-13.5-7.6-26.8-15.5-39.8-23.9-13-8.4-25.7-17-37.7-26.7-5.9-4.7-6.8-13.3-2.1-19.2,4.4-5.4,12-6.6,17.8-3.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-54",
    cx: 367.8,
    cy: 266.4,
    rx: 10.6,
    ry: 6.7,
    transform: "translate(-61.9 413.1) rotate(-54.8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 298,
    y: 233,
    width: 18.5,
    height: 57,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(-94.9 293.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 317.6,
    y: 228.3,
    width: 18.5,
    height: 57,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(557.1 602.9) rotate(-161.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 338.5,
    cy: 240.9,
    r: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M292.6,227.7h1.8c7.7,0,14,6.3,14,14v25.3h-29.8v-25.3c0-7.7,6.3-14,14-14Z",
    transform: "translate(-88.9 280) rotate(-45)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 366,
    cy: 244.9,
    r: 15.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.6,237.2c7.4-4.3,1.8-22.7-9.2-26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.8,215.5s10.1-21.2-7.1-35.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.2,191.5s12.6-14.1,2.5-33.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 239.1,
    cy: 159.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.4,173.4s12.6-16.9.6-29.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 211.9,
    cy: 173.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 216.7,
    cy: 156,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 212.1,
    cy: 144,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 238,
    cy: 190.4,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 243.4,
    cy: 174.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 275.8,
    cy: 217.7,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 279.7,
    cy: 201.7,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 274.8,
    cy: 186,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 317.5,
    cy: 232.2,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 310.5,
    cy: 214.7,
    r: 3.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M254.7,107.9s-2-10,5.1-25.4c7.2-15.4,4-14.1,1.6-15s-19.1,32.1-19.1,32.1l-12.1-4.4s1.4-14.9,12.9-37.2c11.5-22.2,46-34.5,84-7.7,38.1,26.7,24.3,59.8,24.3,59.8l-96.8-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M261.4,67.4c-.2,0-.5,0-.8.4.7-8-4.8-16.3-4.8-16.3,4.1,1.9,4.3,4.4,4.3,4.4,1.3-4.4,4.5-5.6,4.5-5.6-7.6,21.2,6.5,15.4,6.5,15.4,2.1-16.8,22.6-16.9,22.6-16.9-18.2,6.3-15.1,16.1-15.1,16.1,14.5-1.7,22.4,4.2,22.4,4.2-5.2,2.5-13.3,1.9-17.2.4-3.8-1.5-9-4.5-17.5,5.5-8.5,10-6.1,23.5-6.1,23.5,55.6-16.4,88.4-8.2,88.4-8.2l5.3,5.5c0,8.5-2.4,14.2-2.4,14.2l-96.8-2.2s-2-10,5.1-25.4,4-14.1,1.6-15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 231.3,
    cy: 111.4,
    rx: 19,
    ry: 17.9,
    transform: "translate(-14.6 37.8) rotate(-9.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M230.5,122.6c10.4-1.7,17.5-10.9,16-20.6s-.3-1.5-.5-2.3c2.1,2.4,3.6,5.3,4.2,8.7,1.6,9.7-5.6,19-16,20.6-9.5,1.5-18.5-3.9-21-12.4,4.1,4.6,10.6,7,17.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M306.2,94.4c-57,9.1-67.9,10.6-57.3,33.7,10.6,23.1,19.3,6.2,60.5,1.7,41.1-4.5,62.1.4,59.2-23.1-2.9-23.5-12-20.4-62.4-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M248.6,108.4c.3,5.1,3.6,10.9,4.5,15,1.5,6.5,8.1,9.9,35.5,1.3,27.4-8.6,54.3-7.8,65.9-8.4,6.1-.3,11.1-2.6,14.4-5.7,0,19-20.8,15-59.5,19.2-41.1,4.5-49.9,21.4-60.5-1.7-4.4-9.6-5.1-15.5-.4-19.7Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.f12eec722fd72c18e3cc19f7ebac840b.svg";
export { ForwardRef as ReactComponent };